import React, { useState, useEffect } from 'react';
import { FaWallet, FaChartLine, FaCoins, FaRocket } from 'react-icons/fa';
import { useWallet } from '../../context/WalletContext';
import TermsModal from './TermsModal';

const ConnectPrompt = () => {
  const { connectWallet, loading, error } = useWallet();
  const [activeFeature, setActiveFeature] = useState(0);
  const [showTerms, setShowTerms] = useState(false);
  const [skipped, setSkipped] = useState(() => localStorage.getItem('walletPromptSkipped') === 'true');

  const features = [
    { icon: <FaCoins />, title: 'Mine DOLP Tokens', desc: 'Purchase tokens at dynamic prices that increase as supply grows' },
    { icon: <FaChartLine />, title: 'Price Appreciation', desc: 'Token price grows from $1 to $26 as mining progresses' },
    { icon: <FaRocket />, title: 'Built on Polygon', desc: 'Fast, low-cost transactions on Polygon network' },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveFeature((prev) => (prev + 1) % features.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [features.length]);

  if (skipped) return null;
  return (
    <div className="landing-container">
      {error && (
        <div style={{ color: 'red', marginBottom: '1em', fontWeight: 'bold' }}>
          Wallet Error: {error}
        </div>
      )}
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-glow"></div>
        <div className="connect-prompt-container">
          <span>🐬</span>
        </div>
        <h1 className="hero-title">
          <span className="gradient-text">DOLPHIN</span>
        </h1>
        <p className="hero-subtitle">
          The Next Generation Token Mining Ecosystem
        </p>
        <div className="hero-stats">
          <div className="hero-stat">
            <span className="hero-stat-value">960M</span>
            <span className="hero-stat-label">Total Supply</span>
          </div>
          <div className="hero-stat-divider"></div>
          <div className="hero-stat">
            <span className="hero-stat-value">$1-$26</span>
            <span className="hero-stat-label">Price Range</span>
          </div>
        </div>
        <button
          className="btn btn-primary btn-lg connect-btn-hero"
          onClick={() => setShowTerms(true)}
          disabled={loading}
        >
          {loading ? (
            <span className="spinner" />
          ) : (
            <>
              <FaWallet /> Connect Wallet to Start
            </>
          )}
        </button>
        <button
          className="btn btn-secondary btn-sm mt-2"
          style={{marginTop:'1em'}}
          onClick={() => {
            localStorage.setItem('walletPromptSkipped', 'true');
            setSkipped(true);
          }}
        >
          Skip for now
        </button>
        <TermsModal
          open={showTerms}
          onAccept={() => {
            setShowTerms(false);
            connectWallet();
          }}
          onClose={() => setShowTerms(false)}
        />
        {/* Inline styles for modal responsiveness */}
        <style>{`
          .modal-overlay {
            position: fixed;
            top: 0; left: 0; right: 0; bottom: 0;
            background: #7dd3fc; /* Darker overlay */
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1000;
          }
          .modal {
            background: #7dd3fc; /* Dark gray background */
            border-radius: 12px;
            max-width: 95vw;
            width: 400px;
            padding: 2rem 1.5rem;
            box-shadow: 0 4px 24px rgba(0,0,0,0.5); /* Stronger shadow */
            color: #e2e8f0; /* Light gray text */
          }
          .modal-content {
            margin-bottom: 1.5rem;
          }
          .modal-actions {
            display: flex;
            gap: 1rem;
            justify-content: flex-end;
          }
          @media (max-width: 500px) {
            .modal {
              width: 95vw;
              padding: 1rem 0.5rem;
            }
          }
        `}</style>
      </div>

      {/* Features Carousel */}
      <div className="features-section">
        <h3 className="features-title">Why Choose DOLPHIN?</h3>
        <div className="features-carousel">
          {features.map((feature, index) => (
            <div 
              key={index}
              className={`feature-card ${index === activeFeature ? 'active' : ''}`}
              onClick={() => setActiveFeature(index)}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h4>{feature.title}</h4>
              <p>{feature.desc}</p>
            </div>
          ))}
        </div>
        <div className="feature-dots">
          {features.map((_, index) => (
            <span 
              key={index}
              className={`feature-dot ${index === activeFeature ? 'active' : ''}`}
              onClick={() => setActiveFeature(index)}
            />
          ))}
        </div>
      </div>

      {/* How It Works */}
      <div className="how-it-works">
        <h3>How It Works</h3>
        <div className="steps-container">
          <div className="step">
            <div className="step-number">1</div>
            <h4>Connect Wallet</h4>
            <p>Link your MetaMask wallet to get started</p>
          </div>
          <div className="step-arrow">→</div>
          <div className="step">
            <div className="step-number">2</div>
            <h4>Mine Tokens</h4>
            <p>Purchase DOLP at the current mining price</p>
          </div>
          <div className="step-arrow">→</div>
          <div className="step">
            <div className="step-number">3</div>
            <h4>Claim</h4>
            <p>Claim your tokens after mining ends</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectPrompt;
